import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import MainContent from "./maincomponent";
import ProjectPage from "./project";
import Resume from "./resume";
// import Loader from "./loader";

function App() {
  // const [showLoader, setShowLoader] = useState(true);
  // const [showContent, setShowContent] = useState(false);

  // useEffect(() => {
  //   // Simulate loader duration
  //   const loaderDuration = 9000; // 5 seconds

  //   // Hide loader after duration
  //   const loaderTimer = setTimeout(() => {
  //     setShowLoader(false);
  //     setShowContent(true);
  //   }, loaderDuration);

  //   return () => clearTimeout(loaderTimer); // Cleanup timer on unmount
  // }, []);
  const location = useLocation();
  return (
    // {/* <nav>
    //   <Link to="/">Home</Link>
    //   <Link to="/projectpage">ProjectPage</Link>
    // </nav> */}

    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<MainContent />} />
        <Route path="/projectPage" element={<ProjectPage />} />
        <Route path="/resume" element={<Resume />} />
        {/* <Route path="*" element={<ErrorPage />} /> */}
      </Routes>
    </AnimatePresence>
  );
}

export default App;
